/* eslint-disable */
import 'expose-loader?jQuery!imports-loader?this=>window!../../../legacy/src/js/vendor/jquery.1.11.1.min.js'; // TODO Gross, move this over
import 'script-loader?../../../legacy/src/js/vendor/jquery.1.11.1.min.js'; // TODO Gross, move this over
import 'expose-loader?setCookie!exports-loader?setCookie!../../../legacy/src/legacy/js/functions.js';
import 'expose-loader?getCookie!exports-loader?getCookie!../../../legacy/src/legacy/js/functions.js';
import 'expose-loader?getGAEventTrackingCode!exports-loader?getGAEventTrackingCode!../../../legacy/src/legacy/js/functions.js';
import 'imports-loader?this=>window!expose-loader?Cookie!exports-loader?Cookie!../../../legacy/src/legacy/js/cookie.js';
import 'expose-loader?VTK_Utility!exports-loader?VTK_Utility!../../../legacy/src/legacy/js/VTK_utility.js';
import 'expose-loader?HG.EventTracking!exports-loader?HG.EventTracking!../../../legacy/src/js/HG.EventTracking.js';
/* eslint-enable */
window.$ = window.jQuery;



// WEBPACK FOOTER //
// ./footer-hui/scripts/main.js